import { h, render } from 'preact';
import i18next from 'i18next';
import { UserHeaderProperties } from '../models/header-properties';

export const renderHeader = (container: HTMLElement, props: UserHeaderProperties) => {
    const generateUrl = () => {
        const url = encodeURIComponent(window.location.pathname + (window.location.search || ''));
        window.location.href = `/?direction=${url}`;
    };

    const template = props.isLoggedIn ? (
        <div class="d-flex">
            <div>
                <a
                    href='/moncompte/default.aspx'
                    class={`header-user icon-large icon-user cursor-pointer d-none d-l-block td-none ${props.searchbarHighlightFlag ? 'txt-white' : 'txt-black'}`}
                ></a>
            </div>
            <div class="pos-relative">
                <a href="/checkout/cart" class={`td-none ${props.searchbarHighlightFlag ? 'txt-white' : 'txt-black'}`}>
                    <div class="icon icon-cart cursor-pointer fs-7"></div>
                    <div id="js-CartQuantityIcon"></div>
                </a>
            </div>
        </div>
    ) : (
        <div>
            <a
                    class={`${props.searchbarHighlightFlag ? 'txt-white bg-black' : 'txt-black bg-white'}`}
                style="white-space: nowrap;"
                onClick={generateUrl}
                href="#"
                id="loginBtn"
            >
                {i18next.t('alreadymember')}
            </a>
        </div>
    );

    container.innerHTML = '';
    render(template, container);
};
